module.exports = __webpack_public_path__ + "static/media/light-motion-constellation-optimisation.dff63cc.mp4";